import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSuccessComponent } from './custom-success/custom-success.component';
import { CustomErrorComponent } from './custom-error/custom-error.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    CustomSuccessComponent,
    CustomErrorComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    CustomSuccessComponent,
    CustomErrorComponent
  ]
})
export class ToasterComponentModule { }
